import script from "./AdminTextbookManager.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTextbookManager.vue?vue&type=script&setup=true&lang=js"

import "./AdminTextbookManager.vue?vue&type=style&index=0&id=0fcd8604&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fcd8604"]])

export default __exports__